import { User } from "interfaces/user";
import { StaticSplinePanel } from "components/Panels/SplinePanelSmall";
import { AlertTimeSeriesChart } from "components/AlertsManagement/Chart/AlertTimeSeriesChart";
import React from "react";
import { CaseEvent } from "interfaces/case-event";
import { styled } from "@mui/material/styles";
import { ReportCard } from "components/CaseManagement/CaseStream/EventCards/ReportCard";

const CHART_HEIGHT = "300px";

export interface DiagnosticReportCardProps {
  user: User;
  datetime: string;
  caseEvent: CaseEvent;
  refetchCaseEvent(): Promise<void>;
  refetchStream(): Promise<void>;
}

export const DiagnosticReportCard = ({
  user,
  datetime,
  caseEvent,
  refetchCaseEvent,
  refetchStream
}: DiagnosticReportCardProps): JSX.Element => {
  return (
    <ReportCard
      caseEvent={caseEvent}
      user={user}
      datetime={datetime}
      reportName="Diagnostic Report"
      reportType="diagnosis"
      severity={caseEvent.case_severity_type}
      refetchCaseEvent={refetchCaseEvent}
      refetchStream={refetchStream}
    >
      {caseEvent?.params?.trendChartData ? (
        <StaticSplinePanel
          data={caseEvent.params.trendChartData.data}
          width="100%"
          height="300px"
          visibleY={false}
          chartHeight={CHART_HEIGHT}
          legendEnabled={false}
          unit={caseEvent.params.trendChartData.unit}
        />
      ) : null}
      {caseEvent?.params?.alertTimeSeriesMetadata ? (
        <ChartWrapper>
          <AlertTimeSeriesChart
            // @ts-ignore
            tagId={caseEvent.params.alertTimeSeriesMetadata.tagId}
            tagName={caseEvent.params.alertTimeSeriesMetadata.tagName}
            tagUnit={caseEvent.params.alertTimeSeriesMetadata.tagUnit}
            machineId={caseEvent.params.alertTimeSeriesMetadata.machineId}
            severityTypeId={
              caseEvent.params.alertTimeSeriesMetadata.severityTypeId
            }
            ruleId={caseEvent.params.alertTimeSeriesMetadata.ruleId}
            ruleName={caseEvent.params.alertTimeSeriesMetadata.ruleName}
          />
        </ChartWrapper>
      ) : null}
    </ReportCard>
  );
};

const ChartWrapper = styled("div")`
  padding: ${props => props.theme.spacing(2)};
`;
